export const queryKeys = {
  auth: {
    access: (userId: string | null | undefined) =>
      ["auth", "access", userId ?? "anonymous"] as const,
  },
  system: {
    battleBots: () => ["system", "battleBots", "public"] as const,
  },
  admin: {
    invitations: (userId: string | null | undefined) =>
      ["admin", "invitations", userId ?? "anonymous"] as const,
    systemBattleBots: (userId: string | null | undefined) =>
      ["admin", "systemBattleBots", userId ?? "anonymous"] as const,
  },
  library: {
    cards: (userId: string | null | undefined) =>
      ["library", "cards", userId ?? "anonymous"] as const,
    decks: (userId: string | null | undefined) =>
      ["library", "decks", userId ?? "anonymous"] as const,
    heroes: (userId: string | null | undefined) =>
      ["library", "heroes", userId ?? "anonymous"] as const,
  },
  social: {
    snapshot: (userId: string | null | undefined) =>
      ["social", "snapshot", userId ?? "anonymous"] as const,
    profileByFriendCode: (
      userId: string | null | undefined,
      friendCode: string,
    ) =>
      [
        "social",
        "profileByFriendCode",
        userId ?? "anonymous",
        friendCode,
      ] as const,
  },
} as const
